import { InfoWindow as GoogleInfoWindow } from "@vis.gl/react-google-maps";
import React, { useEffect, useState } from "react";
import useSrlHelper from "../../hooks/useSrlHelper";
import { Card } from "react-bootstrap";
import { X } from "react-feather";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import SrlLastLocation from "../../srl/components/SrlLastLocation";
import LastLocation from "../LastLocation";
import "./InfoWindow.css";

const thingsArr = {
  asset: "assets",
  person: "people",
  zone: "zones",
  assets: "assets",
  people: "people",
  zones: "zones",
};

function DeferredInfoWindow(props) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => {
      cancelAnimationFrame(id);
      setReady(false);
    };
  }, []);

  if (!ready) return null;

  return <GoogleInfoWindow {...props} />;
}

const InfoWindow = ({ clickTarget, marker, item, onClose }) => {
  // const [zIndex, setZIndex] = useState(10000000);
  const { isSrl, itemDisplayName } = useSrlHelper();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => {
      cancelAnimationFrame(id);
      setReady(false);
    };
  }, []);

  if (!ready) return null;

  // useEffect(() => {
  //   if (item.active) {
  //     setZIndex(10000001);
  //   } else {
  //     setZIndex(10000000);
  //   }
  // }, [item.active]);

  // console.log("REDAY");

  return (
    <GoogleInfoWindow
      anchor={marker}
      pixelOffset={[0, 8]}
      // shouldFocus={true}
      disableAutoPan={true}
      onClick={(e) => {
        e.stopPropagation();
        clickTarget?.(item);
      }}
      onLoad
      onClose={onClose}
      headerContent={
        <NavLink
          className={"p-0 m-0"}
          to={{
            pathname: `/${thingsArr[item.lastPosition.type]}/edit`,
            search: `?id=${item.lastPosition.id}`,
          }}
        >
          {/* {itemDisplayName(item.lastPosition)} */}
          {isSrl() ? (
            <>{itemDisplayName(item.lastPosition)}</>
          ) : (
            <>
              {item.lastPosition.compoundName}&nbsp;
              {item.lastPosition?.reference
                ? `(${item.lastPosition.reference})`
                : ""}
            </>
          )}
        </NavLink>
      }
    >
      {/* <Card className="m-0 p-0">
        <Card.Body className="pb-0 pt-0 pe-1 ps-2">
          <X
            className="float-end cursor-pointer"
            size={18}
            onClick={(e) => onClose(e)}
          />
          <h5 className="mt-0 mb-0">
            <NavLink
              to={{
                pathname: `/${thingsArr[item.lastPosition.type]}/edit`,
                search: `?id=${item.lastPosition.id}`,
              }}
            >
              {isSrl() ? (
                <>{itemDisplayName(item.lastPosition)}</>
              ) : (
                <>
                  {item.lastPosition.compoundName}{" "}
                  {item.lastPosition?.reference
                    ? `(${item.lastPosition.reference})`
                    : ""}
                </>
              )}
            </NavLink>
          </h5>
        </Card.Body>
      </Card> */}
      <div>
        {isSrl() ? (
          <>
            {item.lastPosition && (
              <React.Fragment>
                <div
                  data-toggle="tooltip"
                  title=""
                  data-placement="right"
                  className="text-nowrap m-0 p-0"
                >
                  <FontAwesomeIcon
                    icon={faLink}
                    fixedWidth
                    className="me-1 p-0"
                  />
                  SRL Fleet #: <b>{item.lastPosition.fleetNumber}</b>
                </div>
                <div
                  data-toggle="tooltip"
                  title=""
                  data-placement="right"
                  className="text-nowrap"
                >
                  <FontAwesomeIcon icon={faLink} fixedWidth className="me-1" />
                  Customer Fleet #: <b>{item.lastPosition.suppString2}</b>
                </div>
              </React.Fragment>
              // <Card className="mb-0">
              //   <Card.Body className={"p-0"}>
              //     <div
              //       data-toggle="tooltip"
              //       title=""
              //       data-placement="right"
              //       className="text-nowrap"
              //     >
              //       <FontAwesomeIcon
              //         icon={faLink}
              //         fixedWidth
              //         className="me-1"
              //       />{" "}
              //       SRL Fleet #: <b>{item.lastPosition.fleetNumber}</b>
              //     </div>
              //     <div
              //       data-toggle="tooltip"
              //       title=""
              //       data-placement="right"
              //       className="text-nowrap"
              //     >
              //       <FontAwesomeIcon
              //         icon={faLink}
              //         fixedWidth
              //         className="me-1"
              //       />{" "}
              //       Customer Fleet #: <b>{item.lastPosition.suppString2}</b>
              //     </div>
              //   </Card.Body>
              // </Card>
            )}
          </>
        ) : (
          <></>
        )}
        {isSrl() ? (
          <SrlLastLocation profile={item} markerLabel detail />
        ) : (
          <LastLocation profile={item} markerLabel detail justList={true} />
        )}
      </div>
    </GoogleInfoWindow>
  );
};

export default InfoWindow;
